module.exports = __webpack_public_path__ + "static/media/spiner.984381ca.gif";